import type { PhaseReturn } from "../../../common/types.ts";

const newPhaseAfterTradeDeadline = (): PhaseReturn => {
	return {};
};

export default newPhaseAfterTradeDeadline;
